import { Alert } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { billingCurrentApi } from "../../config/Api";

// shown inside the app from 7 days before a paid plan ends (an expired plan blocks the app instead)
export const PlanExpiryBanner = () => {
    const [current, setCurrent] = useState(null)

    useEffect(() => {
        billingCurrentApi().then((res) => setCurrent(res.data.data)).catch(() => {})
    }, [])

    if (!current || current.days_left === null || current.days_left > 7) return null

    const when = current.days_left <= 0 ? 'today' : current.days_left === 1 ? 'tomorrow' : `in ${current.days_left} days`

    return (
        <Alert
            type="warning"
            showIcon
            className="mb-3"
            message={<>
                Your {current.plan?.name} plan ends {when} ({moment(current.ends_at).format('DD MMM YYYY')}). {' '}
                <Link to="/my-plan">Renew now</Link> to keep using Nutri Nexus without interruption.
            </>}
        />
    )
}
